import React from 'react';
import { FolderIcon } from '@heroicons/react/outline';

/**
 * Custom drag layer preview shown while dragging a folder.
 * Renders a compact card with the folder icon and name, rotated slightly
 * to convey the "grabbed" state.
 * @param {Object} props Component props
 * @param {Object} props.folder Folder record being dragged
 * @param {string} props.folder.name Display name of the folder
 * @returns {JSX.Element} Styled preview card
 */
const CustomFolderPreview = ({ folder }) => {
    return (
        <div className="bg-white p-4 rounded-lg border border-blue-400 shadow-lg max-w-[250px] rotate-[2deg]">
            <div className="flex items-center gap-3">
                <div className="p-2 bg-blue-50 rounded-lg">
                    <FolderIcon className="h-5 w-5 text-blue-500" />
                </div>
                <span className="text-base font-medium text-gray-900 truncate">
                    {folder.name}
                </span>
            </div>
        </div>
    );
};

export default CustomFolderPreview;